import { render } from "./PayHeader.vue?vue&type=template&id=12e54686"
import script from "./PayHeader.vue?vue&type=script&lang=js"
export * from "./PayHeader.vue?vue&type=script&lang=js"

import "./PayHeader.vue?vue&type=style&index=0&id=12e54686&lang=css"

import exportComponent from "/opt/apps/acquiring_front_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__